var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('loading-spinner')]:[(_vm.showHeader)?_c('risk-header',{attrs:{"risk":_vm.risk,"actionsSecondary":_vm.headerActionsIsSecondary}}):_vm._e(),_vm._v(" "),(_vm.pageComponent)?_c(_vm.pageComponent,{tag:"component",attrs:{"risk":_vm.risk}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }